export default "__VITE_ASSET__Cyj3xlgU__"